import { render, staticRenderFns } from "./PluginsList.vue?vue&type=template&id=12445c88&scoped=true"
import script from "./PluginsList.vue?vue&type=script&lang=js"
export * from "./PluginsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12445c88",
  null
  
)

export default component.exports